import {
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid-premium';

const IncQuickFilterToolbar = () => {
  return (
    <GridToolbarContainer>
      <GridToolbarQuickFilter size="medium" />
    </GridToolbarContainer>
  );
};

export default IncQuickFilterToolbar;
